import { useCookies } from 'react-cookie';
import { COOKIES } from '../constants/misc.js';

const getInitialContextValues = () => {
    var _a, _b, _c;
    const [cookies] = useCookies([]);
    const initialContext = {
        phoneNum: cookies.phoneNum,
        name: cookies.name,
        userId: cookies.ui,
        companyId: cookies[COOKIES.companyId],
        companyLocation: cookies[COOKIES.companyLocation],
        customerCompanyId: cookies[COOKIES.customerCompanyId],
        companyLogo: cookies.cLogo,
        isPhoneVerified: !!+cookies.vv,
        numOfContactRqsts: +cookies.numOfContactRqsts,
        transporterContactsRqstd: cookies.tcr || [],
        kycPopupInitialLoad: cookies.kip || 0,
        historyLocation: cookies.hl,
        isMobile: true,
        currentLocation: { status: "notRequested" },
        profilesViewed: [],
        bulkRequestIds: cookies[COOKIES.bulkRequestIdArray] || [],
        isBulkUploadModalOpen: false,
        eventCounts: {
            citySearchCount: (_a = cookies[COOKIES.citySearchCount]) !== null && _a !== void 0 ? _a : 0,
            transporterSearchCount: (_b = cookies[COOKIES.transporterSearchCount]) !== null && _b !== void 0 ? _b : 0
        },
        showAppMandatePopup: false,
        thirdPartyCompanyName: (_c = cookies[COOKIES.thirdPartyCompanyName]) !== null && _c !== void 0 ? _c : "",
        isProductionEnv: false,
        isMobileScreen: false,
        isLorryNotAllowedPopupOpen: false,
        toggleIsLorryNotAllowedPopupOpen: () => { },
        joinedOn: ""
    };
    return initialContext;
};

export { getInitialContextValues };
//# sourceMappingURL=getInitialContextValues.js.map
